import SpellsSpell from './SpellsSpell';

export default SpellsSpell;
export { SpellsSpell };
